/**
 * Compute the destination `to` object for the legacy /registry →
 * /certificates redirect. Forwards search + hash verbatim so that
 * URLs like /registry?album=wc2026#results survive the redirect as
 * /certificates?album=wc2026#results.
 *
 * Exported from a standalone module (no React or react-router-dom
 * imports) so it can be unit-tested without a renderer.
 */
export function registryLegacyRedirectTarget(location) {
  return {
    pathname: "/certificates",
    search: (location && location.search) || "",
    hash: (location && location.hash) || "",
  };
}
